<div class="container">
<mat-card class="card2">
        <h4 class="card-title">Add member</h4>
    <form (ngSubmit)="f.form.valid && addMember()" #f="ngForm">
        <label>
            <img [src]="addForm.image.url" #ima class="img1">
            <input type="file"  accept="image/*" (onclick)="ima" (change)="showPreview($event)" hidden/>
          </label>
          <div *ngIf="currentUpload">
            Progress: {{ currentUpload?.progress }}%
            Complete
            <div class="progress">
              <div
                class="progress-bar progress-bar-animated"
                [ngStyle]="{ width: currentUpload?.progress + '%' }"
              ></div>
              </div></div>
          <div *ngIf="delete1"><mat-icon class="delete" (click)="deletePreviousFile()">delete</mat-icon></div>
          <br>
          <div class="row">

        <div class="col-md-4">

        
  <mat-form-field class="example-full-width">
    <mat-label>Full Name</mat-label>
    <input matInput placeholder="Full Name" name="fullname" [(ngModel)]="addForm.fullname"  value="" #firstName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" required />
    <span matPrefix><mat-icon>face</mat-icon></span>
    <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback abcd">
      <div *ngIf="firstName.errors.required">Name is required</div>
  </div>   -->
  </mat-form-field>
   
  <div
  [hidden]="firstName.valid || firstName.pristine"
  class="erro1"
>Name is Required
</div>
        </div>  
        <div class="col-md-4">
          <mat-form-field class="example-full-width">
            <mat-label>Email</mat-label>
            <input matInput type="email" placeholder="Email" name="email" [(ngModel)]="addForm.email" #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required email />
           
            <span matPrefix><mat-icon>email</mat-icon></span>
            <!-- <div *ngIf="f.submitted && email.invalid" class="invalid-feedback abcd">
                <div *ngIf="email.errors.required">Email is required</div>
                <div *ngIf="email.errors.email">Email must be a valid email address</div>
            </div> -->

          </mat-form-field>
         <div
            [hidden]="email.valid || email.pristine"
            class="erro1"
          >
            <div *ngIf="email.errors?.required">Email is required</div>
            <div *ngIf="email.errors?.email">
              Email must be a valid email address
            </div>
          </div></div>
          
<div class="col-md-4">
  <mat-form-field class="example-full-width">
    <mat-label>Password</mat-label>
    <input matInput type="password" placeholder="password" name="password" [(ngModel)]="addForm.password" #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" required />
    <span matPrefix><mat-icon>lock</mat-icon></span>
    <!-- <div *ngIf="f.submitted && password.invalid" class="invalid-feedback abcd">
      <div *ngIf="password.errors.required">Password is required</div>
  </div> -->
  </mat-form-field>
  <div
  [hidden]="password.valid || password.pristine"
  class="erro1"
>
  Password is required.
</div>

</div>
<div class="col-md-4">
  <mat-form-field class="example-full-width">
    <mat-label>Phone</mat-label>
    <input matInput placeholder="Phone No" type='tel' name="phone" [(ngModel)]="addForm.phone" #phone="ngModel" required minlength="10" maxlength='10'>
    <span matPrefix>   <mat-icon>phone</mat-icon></span>
    <!-- <div *ngIf="f.submitted && phone.invalid" class="invalid-feedback abcd">
      <div *ngIf="phone.errors.required">Phone is required</div>
  </div> -->
  </mat-form-field> 
  
  <div
  [hidden]="phone.valid || phone.pristine"
  class="erro1"
>
Phone is required.
</div>
</div>
<div class="col-md-4">

  <mat-form-field class="example-full-width">
    <mat-label>Home Address</mat-label>
    <input matInput placeholder="Address" name="address" [(ngModel)]="home" value="">
    <span matPrefix><mat-icon>location_on</mat-icon></span> 
  </mat-form-field>
</div>


          </div>
       
       
          <!-- <mat-form-field class="example-full-width">
         
                <mat-label>Payment Option</mat-label>
                <mat-select #mySel matNativeControl [(ngModel)]="addForm.paymentOption" name="unit" multiple="true"  (selectionChange)="paymentChange($event.value)">
                    <mat-option [value]="0" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option [value]="credit" >Credit</mat-option>
                  <mat-option [value]="debit">Debit</mat-option>
                  <mat-option [value]="upi">UPI</mat-option>

                </mat-select>
          </mat-form-field> -->
      
      
          

          <br>
          <button mat-button mat-raised-button [disabled]="f.invalid" class="btn" class="add">ADD USER</button>
    </form>
    </mat-card>
  </div> 